define('lq/events/actions/setParameterFromEvent',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function SetParameterFromEvent(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(SetParameterFromEvent, EventAction);

    SetParameterFromEvent.typeName = 'SetParameterFromEvent';

    SetParameterFromEvent.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };
    
    SetParameterFromEvent.prototype.execute = function (continuation, eventActionResponse) {
        if (this.eventArg === null)
            this.eventArg = undefined;

        var targetParameters = this.eventData.global
            ? this.piping.parameters.globals
            : this.piping.parameters.locals;
        targetParameters.setValue(this.eventData.parameter, this.eventArg);

		continuation();
    };

    return SetParameterFromEvent;
});
